<template>
	<el-select
	    v-model="platform_id"
	    filterable
	    placeholder="平台"
	    clearable
	    @change="choosePlatform"
	    :style="{ width }"
	    collapse-tags
	    no-data-text="请先选择平台"
	    default-first-option
	    :size="size"
	>
	    <el-option
	        v-for="item in options"
	        :key="item.id"
	        :label="item.label"
	        :value="item.id"
	    ></el-option>
	</el-select>
</template>

<script>
import util from "@/util";
import store from "@/store";
import Public from "@/public";
import { mapState } from "vuex";
export default {
	data() {
	    return {
	        options: [],
			platform_id: null
		}
	},
	props: {
	    width: String,
	    size: String, //尺寸
		selectPlatform: null,
	},
	async mounted() {
	    await this.getData();
	},
	updated() {
	    this.platform_id = this.selectPlatform;
	},
	watch: {
	    selectPlatform: {
	        handler(val) {
	            this.platform_id = val;
	        },
	        deep: true,
	    },
	},
	computed: {
	    ...mapState(["platformList"]),
	},
	methods: {
	    async getData() {
	        let postData = {};
	        await store.dispatch("getplatformList", postData);
	        let arrs = [];
	        for (let i = 0; i < this.platformList.length; i++) {
	            let arr = {
	                id: this.platformList[i].id,
	                label: this.platformList[i].platform_name,
	            };
	            arrs.push(arr);
	        }
			console.log(arrs)
	        this.options = JSON.parse(JSON.stringify(arrs));
	    },
	    /*选择平台*/
	    choosePlatform(e) {
			this.$emit("choose", e);
	    },
	},
}
</script>

<style>
</style>